<template>
  <teleport to="body">
    <div class="modal" v-if="showModal" @click.self.prevent="showModal != showModal">
      <div class="wrapper">
        <font-awesome-icon icon="fa-xmark" class="exit" @click="closed" />
        <section class="content">
          <h3 v-if="newStation">Create New POS Station for {{ station.site }}</h3>
          <h3 v-else>Edit POS Station</h3>
          <form @submit.prevent.stop="submit">
            <div class="info">
              <h4>Station Name: {{ openStation.name }}</h4>
              <input type="text" v-model="openStation.name" v-if="newStation" placeholder="Station Name..." required />
              <button @click.stop.prevent="eftposNZ = !eftposNZ">EFTPOS NZ settings</button>
              <div class="station-type">
                <h4>Station acting as:</h4>
                <Carousel :items="stationTypes" :style="'arrow'" @select-item="setStationType" />
                <button v-if="showSatButton" @click.stop.prevent="$router.push('floorplan/' + station.site)">Edit Floorplan</button>
              </div>
              <div v-if="eftposNZ" class="eftposNZSettings">
                <h4>Eftpos Settings:</h4>
                <label for="ip">IP Address:</label>
                <input type="text" name="ip" v-model="openStation.eftpos.ip" placeholder="IP Address" />
                <label for="port">Port:</label>
                <input type="text" name="port" v-model="openStation.eftpos.port" placeholder="Port" />
              </div>
            </div>
            <div class="action-btns">
              <button v-if="newStation" @click="createStation" class="button create action-colour">Create</button>
              <button v-else class="button action-colour">
                <div @click="updateStation">Update</div>
              </button>
              <button class="button delete danger" v-if="!newStation" @click="deleteStation">
                <div>Delete</div>
              </button>
            </div>
          </form>
        </section>
      </div>
    </div>
  </teleport>
</template>
<script>
import { api } from "@monolith/helpers";
import { mapGetters } from "vuex";
import { Carousel } from "@monolith/components";

export default {
  name: "POSStationModal",
  props: ["open", "station", "newStation"],
  emits: ["update", "close"],
  components: { Carousel },
  data() {
    return {
      showModal: false,
      openStation: null,
      eftposNZ: false,
      kiosk: false,
      satellite: false,
      showSatButton: false,
      stationTypes: [
        { value: "POS", name: "POS", selected: this.kiosk === false && this.satellite === false ? true : false },
        { value: "Kiosk", name: "Kiosk", selected: this.kiosk },
        { value: "Satellite", name: "Satellite", selected: this.satellite },
      ],
    };
  },

  computed: {
    ...mapGetters({
      channels: "channels",
      siteMap: "siteMap",
      siteSettings: "siteSettings",
    }),
  },
  watch: {
    async open() {
      if (!this.open) {
        this.showModal = false;
        return;
      }
      this.showModal = true;
      this.openStation = { ...this.station };
      this.kiosk = "kiosk" in this.openStation ? this.openStation.kiosk : false;
      this.satellite = "satellite" in this.openStation ? this.openStation.satellite : false;
      this.stationTypes = [
        { value: "POS", name: "POS", selected: this.kiosk === false && this.satellite === false ? true : false },
        { value: "Kiosk", name: "Kiosk", selected: this.kiosk },
        { value: "Satellite", name: "Satellite", selected: this.satellite },
      ];
    },
  },
  methods: {
    closed() {
      this.$emit("close");
      this.showModal = false;
      this.eftposNZ = false;
    },

    setStationType(type) {
      if (type == "Kiosk") {
        this.openStation.kiosk = true;
        this.openStation.satellite = false;
        this.showSatButton = false;
      } else if (type == "Satellite") {
        this.showSatButton = true;
        this.openStation.satellite = true;
        this.openStation.kiosk = false;
      } else {
        this.showSatButton = false;
        this.openStation.kiosk = false;
        this.openStation.satellite = false;
      }
    },

    async createStation() {
      this.$store.dispatch("loading", true);
      delete this.openStation.active;
      let createdStation = {
        eftpos: {
          ip: null,
          port: null,
        },
        kiosk: this.openStation.kiosk || false,
        satellite: this.openStation.satellite || false,
        name: this.openStation.name,
        site: this.station.site,
      };
      await api.post("/api/company/add_station", { site: this.station.site, station: createdStation, station_type: "get_pos" });
      await this.$store.dispatch("initialSiteMap");
      this.$store.dispatch("loading", false);
      this.closed();
    },
    async updateStation() {
      // delete this.openStation.active;
      this.$emit("update", "update", "pos", this.openStation);
    },
    async deleteStation() {
      this.$emit("update", "delete", "pos", this.openStation);
    },
  },
};
</script>
<style scoped lang="scss">
@use "@monolith/styles";

h3 {
  color: var(--text-colour);
  text-align: center;
  margin: 0.5rem;
}

.blue {
  background-color: var(--action-colour) !important;
  color: var(--secondary-text-colour);
}

.active {
  color: var(--action-colour);
}

.discon {
  color: var(--warning-colour);
}

.delete {
  background: var(--warning-colour);
  color: var(--text-colour);
}
form {
  .info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 1rem;
    margin: 1rem;
    input {
      margin: 0.5rem !important;
      border-radius: 0.25rem;
      border: none;
      padding: 0.5rem;
    }
    h4 {
      color: var(--text-colour);
      padding: 0;
      margin: 0;
    }
    div {
      display: flex;
      flex-direction: column;
      input {
        margin: 0.5rem !important;
        border-radius: 0.25rem;
        border: none;
        padding: 0.5rem 2.5rem 0.5rem 0.5rem;
      }
      label {
        color: var(--action-colour);
      }
    }
    button {
      background-color: var(--primary-colour);
      color: var(--text-colour);
      border: none;
      padding: 0.5rem 5rem;
      margin: auto;
      border-radius: 0.5rem;
      box-shadow: var(--box-shadow);
      cursor: pointer;
      // width: 100%;
    }
  }
  .station-type {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .action-btns {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    margin: 0 auto;
    .create {
      background-color: var(--action-colour) !important;
      color: var(--secondary-text-colour) !important;
      padding: 0.75rem 5rem;
    }
  }
}

.status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin: 1rem;
  color: var(--text-colour);
}
@media only screen and (orientation: portrait) {
  .eftposNZSettings {
    input{
      padding: 0.5rem 1rem 0.5rem 0.5rem !important;
    }
  }
}
</style>
